(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(72098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(60699);
// EXTERNAL MODULE: ./src/utils/uploadUtils.ts
var uploadUtils = __webpack_require__(80831);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx
var Button = __webpack_require__(91468);
;// CONCATENATED MODULE: ./src/components/molecules/HighligtedCourse/index.tsx





const HighligtedCourse = (param)=>{
    let { course  } = param;
    const { id , attributes  } = course;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden rounded-lg bg-white shadow",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex flex-col items-start justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,uploadUtils/* getUploadUrl */.M)(attributes.image.data.attributes),
                            alt: attributes.image.data.attributes.alternativeText,
                            className: "aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]",
                            width: attributes.image.data.attributes.width,
                            height: attributes.image.data.attributes.height
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-xl px-4 py-5 sm:p-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "group relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-3 h-10 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/cursos/".concat(attributes.slug),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "absolute inset-0"
                                        }),
                                        attributes.title
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-5 line-clamp-3 text-sm leading-6 text-gray-600",
                                children: attributes.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "my-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/cursos/".concat(attributes.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "primary",
                                        type: "button",
                                        variant: "solid",
                                        block: true,
                                        children: "Ver Curso"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        }, course.id)
    });
};
/* harmony default export */ var molecules_HighligtedCourse = (HighligtedCourse);

;// CONCATENATED MODULE: ./src/components/organisms/HIghlightedCourses/index.tsx



const HighligtedCourses = (param)=>{
    let { courses  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: "my-8 lg:my-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 text-center lg:mb-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                        children: "Elige un curso y empieza a aprender"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-auto mt-3 max-w-3xl text-gray-500 sm:mt-4",
                        children: "Aprende programaci\xf3n con los cursos b\xe1sicos y practica con los ejercicios dentro de cada curso."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                role: "list",
                className: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3",
                children: courses.map((course)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_HighligtedCourse, {
                            course: course
                        })
                    }, course.id))
            })
        ]
    });
};
/* harmony default export */ var HIghlightedCourses = (HighligtedCourses); // Path: components/organisms/HIghlightedCourses/index.tsx

// EXTERNAL MODULE: ./src/components/templates/Home/Hero.tsx
var Hero = __webpack_require__(77886);
// EXTERNAL MODULE: ./src/components/templates/Home/PrimaryFeatures.tsx + 2 modules
var PrimaryFeatures = __webpack_require__(44712);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(96348);
;// CONCATENATED MODULE: ./src/pages/index.tsx







const Home = (param)=>{
    let { data , courses  } = param;
    const { user  } = (0,AuthContext/* useAuth */.a)();
    const hero = data.attributes.content.find((c)=>c.__component === "shared.hero");
    const sectionTitle = data.attributes.content.find((c)=>c.__component === "shared.section-title");
    const features = data.attributes.content.find((c)=>c.__component === "page.features");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLayout/* default */.Z, {
        seo: data.attributes.seo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                ...hero,
                button: {
                    label: "Ver cursos",
                    url: "/cursos"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "features",
                "aria-label": "Features for investing all your money",
                className: "bg-dark py-20 sm:py-36",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto lg:mx-0 lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-medium tracking-tight text-white",
                                children: sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-lg text-gray-200",
                                children: sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.subTitle
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryFeatures/* default */.Z, {
                features: features.features
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HIghlightedCourses, {
                courses: courses
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [789,1664,2552,9842,2792,9746,5519,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);